import { type AxiosRequestConfig } from 'axios';

export const toQueryString = (params?: AxiosRequestConfig['params']) => {
  if (!params || typeof params !== 'object') {
    return '';
  }

  const normalizedParams = params as Record<string, unknown>;
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(normalizedParams)) {
    if (value === undefined || value === null) {
      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        searchParams.append(key, String(item));
      }
      continue;
    }

    searchParams.append(key, String(value));
  }

  return searchParams.toString();
};
